import "chart.js/auto";
import styles from "../../styles/common/index.module.css";
import { Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Banner = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className={styles.bannerBox}>
        <div>
          <Typography variant="h1" color="#eceff1">
            <div className={styles.main_h1}>
              <span>Project Catalyst</span>
            </div>
          </Typography>
          <Typography variant="h4" color="#eceff1">
            <div className={styles.main_h1}>
              <span>Decentralized Governance in Action</span>
            </div>
          </Typography>
        </div>
        <div className={styles.buttonContainer}>
          <Button onClick={() => navigate("/funds")}>
            <span className={styles.panelRedirectButton}>
              <span className={styles.circle} aria-hidden="true">
                <span className={styles.icon}> </span>
              </span>
              <span className={styles.button_text}>View All Funds</span>
            </span>
          </Button>
          <div>
            <Button onClick={() => navigate("/analytics")}>
              <span className={styles.panelRedirectButton}>
                <span className={styles.circle} aria-hidden="true">
                  <span className={styles.icon}> </span>
                </span>
                <span className={styles.button_text}>Explore Analytics</span>
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
